import Icon from '../icon/Icon';

import styles from '../../styles/modules/layout/App.module.scss';

import useSound from '../../hooks/useSound';

import AuthButtons from '../auth/AuthButtons';

import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

const Header = () => {
	const { muted, toggle } = useSound();

	const { openModal } = useConfigStore((s) => s);

	const openModalHandler = () => {
		openModal(Modal);
	};

	return (
		<div className={styles.header}>
			<div className={styles.logo} onClick={openModalHandler}>
				<Icon name='logo' className={styles['icon-logo']} />
				<Icon name='epicloot' className={styles['icon-epicloot']} />
			</div>

			<div className={styles.sound} onClick={toggle}>
				<Icon name={muted ? 'sound' : 'sound-off'} />
			</div>

			<div onClick={openModalHandler}>
				<AuthButtons
					text='войти'
					className={styles.authButtons}
					classNameTitle={styles.authButtonsTitle}
					classNameButton={styles.authButton}
				/>
			</div>
		</div>
	);
};

export default Header;
